/** KI-Übersetzung TP1 — Admin → API-Einstellungen. */
import { apiV2 } from './api';

export type AiProviderType = 'openai_compatible' | 'bedrock' | 'vertex' | 'deepl';

export interface AiProvider {
  id: number;
  name: string;
  type: AiProviderType;
  base_url: string | null;
  region: string | null;
  project_id: string | null;
  model: string | null;
  timeout_seconds: number;
  is_active: boolean;
  api_key_masked: string | null;
  secret_hint: string | null;
  eu_region: boolean;
}

export interface AiProviderInput {
  name?: string;
  type?: AiProviderType;
  base_url?: string | null;
  region?: string | null;
  project_id?: string | null;
  model?: string | null;
  timeout_seconds?: number;
  is_active?: boolean;
  /** Leer lassen = gespeicherten Wert behalten. */
  api_key?: string;
  secret?: string;
}

export interface TranslationSettingsData {
  enabled: boolean;
  provider_id: number | null;
  fallback_provider_id: number | null;
  instructions: string;
  backfill_batch_size: number;
  backfill_pause_seconds: number;
}

export interface TranslationStatus {
  counts: { ok: number; pending: number; failed: number; stale: number };
  backfill: { done: boolean; processed: number; total: number };
  usage_month: { requests: number; input_units: number; output_units: number; errors: number };
}

export interface ProviderTestResult { ok: boolean; text: string | null; duration_ms: number; error: string | null }

interface Envelope<T> { data: T }

export const aiSettingsApi = {
  listProviders: async () => (await apiV2.get<Envelope<AiProvider[]>>('/admin/ai-providers')).data.data,
  createProvider: async (p: AiProviderInput) => (await apiV2.post<Envelope<AiProvider>>('/admin/ai-providers', p)).data.data,
  updateProvider: async (id: number, p: AiProviderInput) => (await apiV2.put<Envelope<AiProvider>>(`/admin/ai-providers/${id}`, p)).data.data,
  deleteProvider: async (id: number) => { await apiV2.delete(`/admin/ai-providers/${id}`); },
  testProvider: async (id: number) => (await apiV2.post<Envelope<ProviderTestResult>>(`/admin/ai-providers/${id}/test`)).data.data,
  getSettings: async () => (await apiV2.get<Envelope<TranslationSettingsData>>('/admin/translation-settings')).data.data,
  updateSettings: async (s: Partial<TranslationSettingsData>) => (await apiV2.put<Envelope<TranslationSettingsData>>('/admin/translation-settings', s)).data.data,
  status: async () => (await apiV2.get<Envelope<TranslationStatus>>('/admin/translations/status')).data.data,
  retryFailed: async () => (await apiV2.post<Envelope<{ queued: number }>>('/admin/translations/retry-failed')).data.data,
};
